import i18n from '../i18n';

const apartments = {
  studioAp: i18n.t('constants.apartments.studioAp'),
  oneAp: i18n.t('constants.apartments.oneAp'),
  twoAp: i18n.t('constants.apartments.twoAp'),
  threeAp: i18n.t('constants.apartments.threeAp'),
  allAp: i18n.t('constants.apartments.allAp'),
  penthaus: i18n.t('constants.apartments.penthaus')
};

export default apartments;



// WEBPACK FOOTER //
// ./src/constants/apartments.js